module.exports = __webpack_public_path__ + "static/media/08.22760e2d.mp3";